const ADD_TO_CART = 'addToCart'
const SET_ACCOUNT = 'setAccount'
const SET_SITE_TYPE = 'setSiteType'
const SET_CUSTOMER_ID = 'setCustomerId'
const SET_EMAIL = 'setEmail'
const SET_HASHED_EMAIL = 'setHashedEmail'
const TRACK_TRANSACTION = 'trackTransaction'
const VIEW_BASKET = 'viewBasket'
const VIEW_HOME = 'viewHome'
const VIEW_ITEM = 'viewItem'
const VIEW_LIST = 'viewList'

export const TRACK_EVENTS = {
  ADD_TO_CART,
  SET_ACCOUNT,
  SET_SITE_TYPE,
  SET_CUSTOMER_ID,
  SET_EMAIL,
  SET_HASHED_EMAIL,
  TRACK_TRANSACTION,
  VIEW_BASKET
}

export const DEFAULT_PAGE_NAME = 'home'

export const AD_INSERTED = 'adInserted'
export const ADS_DETAIL = VIEW_ITEM
export const ADS_LIST = VIEW_LIST
export const HOME = VIEW_HOME
export const INSTANT_OFFER_APPOINTMENT_CONFIRMED = 'instantOfferAppointmentConfirmed'
export const INSTANT_OFFER_STANDALONE = 'viewInstantOfferStandalone'
export const PTA_CAR_CATEGORY = 'viewPtaCarCategory'
export const STANDALONE_SELECTION = 'viewStandaloneSelection'
export const VIEW_INSTANT_OFFER_FROM_STANDALONE = 'viewInstantOfferFromStandalone'

export const TRACK_PAGE_EVENTS = {
  AD_INSERTED,
  ADS_DETAIL,
  ADS_LIST,
  HOME,
  INSTANT_OFFER_APPOINTMENT_CONFIRMED,
  INSTANT_OFFER_STANDALONE,
  PTA_CAR_CATEGORY,
  STANDALONE_SELECTION,
  VIEW_INSTANT_OFFER_FROM_STANDALONE
}

export const CRITEO_EVENTS = {
  [AD_INSERTED]: TRACK_TRANSACTION,
  [ADS_DETAIL]: VIEW_ITEM,
  [ADS_LIST]: VIEW_LIST,
  [HOME]: VIEW_HOME,
  [INSTANT_OFFER_APPOINTMENT_CONFIRMED]: TRACK_TRANSACTION,
  [INSTANT_OFFER_STANDALONE]: VIEW_ITEM,
  [PTA_CAR_CATEGORY]: VIEW_ITEM,
  [STANDALONE_SELECTION]: VIEW_HOME,
  [VIEW_INSTANT_OFFER_FROM_STANDALONE]: VIEW_BASKET
}

const MOBILE = 'm'
const DESKTOP = 'd'

export const SITE_TYPES = {
  MOBILE,
  DESKTOP
}

export const CRITEO_ATTRIBUTION_REGEX =
  /.*utm_medium=retargeting(&|$).*utm_source=criteo(&|$).*utm_campaign=marketplace_display(&|$)/i

export const CRITEO_ATTRIBUTION_SESSION_KEY = 'isCriteo'
export const IS_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE = 1
export const IS_NOT_CRITEO_ATTRIBUTION_DEDUPLICATION_VALUE = 0

export const CRITEO_FREESPEE_SESSION_ID_SEPARATOR = '@@@@'
export const CRITEO_FREESPEE_BASE_PIXEL_URL =
  '//gum.criteo.com/sync?c=69&a=1&r=1&u=https%3A%2F%2Fanalytics.freespee.com%2Fexternal%2Fc_pixel%3Fcriteoid%3D%40USERID%40%26mp_uid%3D'
export const CRITEO_FREESPEE_ITEM_ID = 16413

export const DEFAULT_EVENT_VALUE_FOR_NO_RELEVANT_PROPERTIES = 1
export const VENTA_EVENT_RELATED_TO_PRIVATE_SELLER_VALUE = 0
export const VENTA_EVENT_RELATED_TO_PROFESSIONAL_SELLER_VALUE = 1
